export default __webpack_public_path__ + "static/media/partnerBg.169a3c86.webp";